module.exports = "<bulk-scripts-page></bulk-scripts-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bulkScripts.html
// module id = 2080
// module chunks = 0